export enum FormType {
    DEFAULT = 'default',
    ADVANCED_LICENSE = 'advancedLicense',
    STANDARD_LICENSE = 'standardLicense',
    ASSISTED_SOLUTIONS = 'assistedSolutions',
    TOLUNASTART_QUAL = 'tolunastartQual',
    AD_REVIEW = 'adReview',
    CUSTOM = 'custom',
}

export enum ContactUsFormHelpOptions {
    OPTION_1 = 'option1',
    OPTION_2 = 'option2',
    OPTION_3 = 'option3',
    OPTION_4 = 'option4',
    OPTION_6 = 'option6',
    OPTION_7 = 'option7',
    REQUEST_ADVANCED_LICENSE = 'option8',
    REQUEST_STANDARD_LICENSE = 'option9',
    OPTION_11 = 'option11',
    TOLUNA_START_QUAL = 'option12',
    AD_REVIEW = 'option13',
    DIY_SOULUTIONS = 'option14',
    SERVICED_SOLUTIONS = 'option15',
    PRODUCT_AND_INNOVATION_SOLUTIONS = 'option16',
    BRAND_AND_CAMPAIGN_SOLUTIONS = 'option17',
    TOLUNA_HARMONALZE_PERSONAS = 'option18',
}

export const validationFields = {
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    COMPANY_NAME: 'companyName',
};
